import { useCallback, useState } from 'react';

const readStoredBoolean = (key: string): boolean => {
  try {
    return localStorage.getItem(key) === 'true';
  } catch {
    return false;
  }
};

export const useStoredBoolean = (
  key: string,
): [boolean, (value: boolean) => void] => {
  const [value, setValue] = useState<boolean>(() => readStoredBoolean(key));

  const setStoredValue = useCallback(
    (next: boolean) => {
      setValue(next);
      try {
        localStorage.setItem(key, String(next));
      } catch {
        // Ignore write failures (private mode / quota exceeded).
      }
    },
    [key],
  );

  return [value, setStoredValue];
};
